import { render, staticRenderFns } from "./com-config.vue?vue&type=template&id=500bf324&scoped=true"
import script from "./com-config.vue?vue&type=script&lang=js"
export * from "./com-config.vue?vue&type=script&lang=js"
import style0 from "./com-config.vue?vue&type=style&index=0&id=500bf324&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500bf324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500bf324')) {
      api.createRecord('500bf324', component.options)
    } else {
      api.reload('500bf324', component.options)
    }
    module.hot.accept("./com-config.vue?vue&type=template&id=500bf324&scoped=true", function () {
      api.rerender('500bf324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/common/com-config.vue"
export default component.exports